module.exports = __webpack_public_path__ + "static/img/home01.6ecf236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home01.png
// module id = 30FK
// module chunks = 1